import type { WorldQuiz } from './game';

export const registry: { game: WorldQuiz | null } = { game: null };
